"use strict";

exports.__esModule = true;
exports.DeviceColorSource = DeviceColorSource;
exports.toStringLowerCase = exports.RAW_VALUE_LOWER_THAN = exports.RAW_VALUE_GREATER_THAN = exports.RAW_VALUE_EQUALS = exports.RAW_VALUE_CONTAINS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _DeviceCycleColorSource = require("./DeviceCycleColorSource");
var _DeviceMetricColorSource = require("./DeviceMetricColorSource");
var _Catalogs = require("../../../Catalogs");
var _modernDocumentColor = require("../../Theme/UiDesign/modernDocumentColor");
var _excluded = ["realtime", "config", "deviceUuid", "children", "defaultColor", "value"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var toStringLowerCase = exports.toStringLowerCase = function toStringLowerCase(val) {
  return (val || "").toString().toLowerCase().trim().replace(/[ ._-]/gi, "");
};
var RAW_VALUE_EQUALS = exports.RAW_VALUE_EQUALS = "EQ";
var RAW_VALUE_LOWER_THAN = exports.RAW_VALUE_LOWER_THAN = "LT";
var RAW_VALUE_GREATER_THAN = exports.RAW_VALUE_GREATER_THAN = "GT";
var RAW_VALUE_CONTAINS = exports.RAW_VALUE_CONTAINS = "CONTAINS";
function updateProps(config, commonProps, extra, realtime) {
  // This is because metric based color source can be configurable by the component for historical/realtime
  if (config.type === "metric") {
    return Object.assign({}, commonProps, extra, {
      realtime: realtime,
      metric: (0, _Catalogs.getMetricDefinition)(config.name)
    });
  }

  // `timeseries` color source sets color based on realtime values by default.
  return Object.assign({}, commonProps, extra);
}
var valueMatchers = function valueMatchers(valueType, value) {
  return valueType === "numerical" ? {
    findMatchingEqualsToValue: function findMatchingEqualsToValue(tuple) {
      return Number(tuple.value) === value;
    },
    findMatchingLowerThanValue: function findMatchingLowerThanValue(tuple) {
      return Number(tuple.value) > value;
    },
    findMatchingGreaterThanValue: function findMatchingGreaterThanValue(tuple) {
      return Number(tuple.value) < value;
    },
    findMatchingContainsValue: function findMatchingContainsValue(tuple) {
      return toStringLowerCase(value).indexOf(toStringLowerCase(tuple.value)) > -1;
    }
  } : {
    findMatchingEqualsToValue: function findMatchingEqualsToValue(tuple) {
      return toStringLowerCase(tuple.value) === toStringLowerCase(value);
    },
    findMatchingLowerThanValue: function findMatchingLowerThanValue(tuple) {
      return toStringLowerCase(tuple.value) > toStringLowerCase(value);
    },
    findMatchingGreaterThanValue: function findMatchingGreaterThanValue(tuple) {
      return toStringLowerCase(tuple.value) < toStringLowerCase(value);
    },
    findMatchingContainsValue: function findMatchingContainsValue(tuple) {
      return toStringLowerCase(value).indexOf(toStringLowerCase(tuple.value)) > -1;
    }
  };
};
function rawValueRenderer(config, value, children, defaultColor) {
  var _config$backgroundCol = config.backgroundColorValueTuples,
    backgroundColorValueTuples = _config$backgroundCol === void 0 ? [] : _config$backgroundCol;
  var isAnyValueTupleNaN = backgroundColorValueTuples.some(function (_ref) {
    var value = _ref.value;
    return Number.isNaN(Number(value));
  });
  var valueType = "numerical";
  var parsedValue = Number(value);
  if (Number.isNaN(parsedValue) || isAnyValueTupleNaN) {
    parsedValue = value;
    valueType = "string";
  }
  var _valueMatchers = valueMatchers(valueType, parsedValue),
    findMatchingContainsValue = _valueMatchers.findMatchingContainsValue,
    findMatchingEqualsToValue = _valueMatchers.findMatchingEqualsToValue,
    findMatchingGreaterThanValue = _valueMatchers.findMatchingGreaterThanValue,
    findMatchingLowerThanValue = _valueMatchers.findMatchingLowerThanValue;
  var lowerThan = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === RAW_VALUE_LOWER_THAN;
  }).sort(function (a, b) {
    return a.value - b.value;
  });
  var greaterThan = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === RAW_VALUE_GREATER_THAN;
  }).sort(function (a, b) {
    return b.value - a.value;
  });
  var equalsTo = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === RAW_VALUE_EQUALS || !tuple.eqType;
  });
  var contains = backgroundColorValueTuples.filter(function (tuple) {
    return tuple.eqType === RAW_VALUE_CONTAINS;
  });
  var backgroundColorValueTuple = equalsTo.find(findMatchingEqualsToValue) || lowerThan.find(findMatchingLowerThanValue) || greaterThan.find(findMatchingGreaterThanValue) || contains.find(findMatchingContainsValue);
  return children(backgroundColorValueTuple ? backgroundColorValueTuple.color : defaultColor);
}

/**
 * Supplies device colors to consumers via a render prop.
 */
function DeviceColorSource(_ref2) {
  var _ref2$realtime = _ref2.realtime,
    realtime = _ref2$realtime === void 0 ? true : _ref2$realtime,
    config = _ref2.config,
    deviceUuid = _ref2.deviceUuid,
    children = _ref2.children,
    _ref2$defaultColor = _ref2.defaultColor,
    defaultColor = _ref2$defaultColor === void 0 ? "transparent" : _ref2$defaultColor,
    value = _ref2.value,
    extra = _objectWithoutPropertiesLoose(_ref2, _excluded);
  // Colours the document stores follow the modern restyle when it is on.
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  if (config.type === "rawValue") {
    return rawValueRenderer(Object.assign({}, config, {
      backgroundColorValueTuples: (0, _modernDocumentColor.modernizeValueTuples)(theme, config.backgroundColorValueTuples)
    }), value, children, defaultColor);
  }
  if (config.type === "custom") {
    return children((0, _modernDocumentColor.modernizeDocumentColor)(theme, config.customColor) || defaultColor);
  }
  var updatedProps = updateProps(config, {
    deviceUuid: deviceUuid,
    thresholds: (0, _modernDocumentColor.modernizeThresholds)(theme, config.thresholds),
    defaultColor: defaultColor
  }, extra, realtime);
  if (config.type === "timeseries") {
    return /*#__PURE__*/_react["default"].createElement(_DeviceCycleColorSource.DeviceCycleColorSource, updatedProps, children);
  }
  if (config.type === "metric") {
    return /*#__PURE__*/_react["default"].createElement(_DeviceMetricColorSource.DeviceMetricColorSource, updatedProps, children);
  }
  return children(defaultColor);
}